import Vue from 'vue'

export default {
  state: {
    customers: null
  },
  mutations: {
    setCustomers(state, customers) {
      state.customers = customers;
    },
    customersReset(state) {
      state.customers = null;
    },
    customerDelete(state, id) {
      if (state.customers) {
        const index = state.customers.findIndex(customer => customer.id === id);
        if (index !== -1)
          state.customers.splice(index, 1);
      }
    },
    customerAdd(state, customer) {
      if (state.customers) {
        const name = customer.name.toLowerCase();
        const index = state.customers.findIndex(customer => name < customer.name.toLowerCase());
        if (index !== -1)
          state.customers.splice(index, 0, customer);
        else
          state.customers.push(customer);
      }
    },
    customerUpdate(state, customer) {
      if (state.customers) {
        const index = state.customers.findIndex(c => c.id === customer.id);
        if (index !== -1)
          state.customers.splice(index, 1, customer);
      }
    }
  },
  actions: {
    async customers({state, commit}, activeOnly=true) {
      if (!state.customers) {
        const customers = [];
        await Vue.prototype.$lazyListLoad(customers, 'customers2', 'id,name,active,type,currency,term{id},category{id,name},salesRep{id},shipmentZone{id}', 100, []);
        commit('setCustomers', customers);
      }

      return activeOnly ? state.customers.filter(customer => customer.active) : state.customers;
    },
    async customerCreate({commit}, input) {
      const results = await Vue.prototype.$apiCall(`mutation StoreCustomer($input: CustomerInput!) {
                                                      customerCreate(input:$input) {id,name,active,type,currency,salesRep{id},shipmentZone{id}}
                                                    }`,
                                                    {input});
      if (!results.error)
        commit(input.id ? 'customerUpdate' : 'customerAdd', results.data.customerCreate);
      return results;
    }
  }
}